<template>
  <div class="xd-tips">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.xd-tips {
  background: #f9f9fb;
  border: 1px solid #edf1f1;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */

  text-align: justify;
  letter-spacing: -0.2px;

  color: #5c5c5c;
    a {
      text-decoration: underline;
      color: #ff6600;
    }
}
</style>
